import socialMediaServices from '../../services/social_media';
import SocialMedia from '../../model/social_media';

export const state = {
    socials: [],
}

export const mutations = {
    setSocials(state, socials) {
        state.socials = socials
    },
}

export const getters = {
    getSocials(state) {
        return {
            facebook:   new SocialMedia( state.socials.find((x)=>x.type.name == 'facebook') ),
            twitter:    new SocialMedia( state.socials.find((x)=>x.type.name == 'twitter') ),
            instagram:  new SocialMedia( state.socials.find((x)=>x.type.name == 'instagram') ),
            youtube:    new SocialMedia( state.socials.find((x)=>x.type.name == 'youtube') ),
            telegram:   new SocialMedia( state.socials.find((x)=>x.type.name == 'telegram') )
        }
    },
}

export const actions = {
    getAll({commit}, data = {}){
        return socialMediaServices.getAll(data)
        .then((response)=>{
            commit('setSocials', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, social}){
        return socialMediaServices.edit(id, social)
        .then((response)=>{
            let socials = state.socials
            socials[socials.findIndex((x)=>x.id == id)] = response.data
            commit('setSocials', socials)
            return response
        })
    }
}